import { BrowserRouter } from 'react-router-dom';
import Navbar from './Components/Navbar/navbar';
import Home from './Components/Home/home';
import About from './Components/About-us/about-us';
import Footer from './Components/Footer/footer';
import routes from './Shared/Routes/routes';
import Communication from './Pages/Communication';
import Navigation from './Pages/navigation';
import NavigationDetail from './Pages/navigationDetail';
import CommunicationDetail from './Pages/communicationDetail';
import Services from './Pages/services';
import ServiceDetail from './Pages/servicesDetail';
import Contact from './Pages/contact';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './Shared/scrollToTop';

const getComponent = (elementName) => {
  switch (elementName) {
    case 'Home':
      return Home;
    case 'About':
      return About;
    case 'Communication':
      return Communication;
    case 'Navigation':
      return Navigation;
    case 'NavigationDetail':
      return NavigationDetail;
    case 'Services':
      return Services;
      case 'Contact':
      return Contact;
    default:
      return Home;
  }
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            {routes.map((route) => {
              const Component = getComponent(route.element);
              return (
                <Route 
                  key={route.path}
                  path={route.path}
                  element={<Component />}
                />
              );
            })}
            <Route 
              path="/products/navigation/:id" 
              element={<NavigationDetail />} 
            />
            <Route path="/products/communication/:id" element={<CommunicationDetail />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:id" element={<ServiceDetail />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;